import { FEATURES } from '@/pages/Products/CloudFlare/ManageCloudFlareHandler/ManageCloudFlareHandler.types';
import { Button, Link } from 'gatorcomponents';
import React from 'react';
import { format } from 'date-fns';
import { RuleActionTypes } from '@/pages/Products/CloudFlare/ManageCloudFlareHandler/components/Security/Security.types';

export default {
  title: 'CDN - Rendimento del sitio web',
  hostingLabel: 'Hospedaje: ',
  change: 'Cambiar',
  cloudflareCdnExplanation: ({ handleWhatIsCdn }) => (
    <>
      {'Acelere su sitio y obtenga más seguridad al activar la CDN integrada con Cloudflare. '}
      <Button
        variant="text"
        label="¿Qué es CDN?"
        onClick={handleWhatIsCdn}
      />
    </>
  ),
  searchPerDomain: 'Buscar por dominio',
  activateCdn: 'Activar CDN',
  status: {
    nonexistentexternal: 'Pendiente',
    pendinginternal: 'En curso',
    pendingexternal: 'Verificando configuración',
    error: 'Error en la configuración',
    delayinternal: 'Error en la configuración',
    delayexternal: 'Error en la configuración',
    activationpointingerrorinternal: 'En curso',
    activationpointingerrorexternal: 'Verificando configuración',
    pendingdeactivationinternal: 'En curso',
    pendingdeactivationexternal: 'En curso',
    inactivationpointingerrorinternal: 'En curso',
    inactivationpointingerrorexternal: 'Verificando configuración',
    externalproviderinternal: 'En curso',
  },
  manage: 'Administrar',
  externalDomain: 'Dominio no registrado con HostGator. Active el botón y siga las instrucciones para configurarlo en el proveedor de origen.',
  ongoingActivation: (
    <>
      {'El CDN se activará automáticamente después de configurar el dominio. Esto puede tardar hasta 72 horas. '}
      <Link
        text="Comprenda el plazo."
        href="https://suporte.hostgator.com.br/hc/pt-br/articles/30812694986771-O-que-%C3%A9-propaga%C3%A7%C3%A3o"
        target="_blank"
      />
    </>
  ),
  ongoingExternalActivation: 'Por favor, espere. Una vez completada la activación, puede utilizar la CDN.',
  ongoingDeactivation: (
    <>
      {'El CDN se desactivará automáticamente. Esto puede tardar hasta 72 horas. '}
      <Link
        text="Comprenda la fecha límite."
        href="https://suporte.hostgator.com.br/hc/pt-br/articles/30812694986771-O-que-%C3%A9-propaga%C3%A7%C3%A3o"
        target="_blank"
      />
    </>
  ),
  noDomains: 'No se han encontrado resultados para su búsqueda',
  pendingTooltip: 'No es posible cambiar la CDN mientras la activación está en curso',
  cdnAlreadyActive: (
    <span>
      <strong>
        El CDN
      </strong>
      {' ya está activo en este sitio, dejándolo más rápido y seguro.'}
    </span>
  ),
  showMore: 'Mostrar más',
  changePlanModal: {
    title: 'Seleccione un dominio',
    searchPlaceholder: 'Buscar por dominio',
    mainDomain: 'Dominio principal: ',
    back: 'Volver',
    continue: 'Continuar',
  },
  activateDeactivateInternalModal: {
    toActivateTitle: 'Activar CDN',
    toDeactivateTitle: 'Desactivar CDN',
    activatingTitle: 'Activación de CDN en curso',
    deactivatingTitle: 'Desactivación del CDN en curso',
    toActivateDescription: 'Active la CDN y deje su sitio web más rápido y seguro. Los cambios pueden tardar hasta  24 horas.',
    toDeactivateDescription: 'Desactivar la CDN puede dejar más lento y reducir la seguridad de su sitio. Los cambios pueden tardar hasta 24 horas.',
    activatingDescription: 'La activación de su CDN ha sido solicitada y está en curso. Acompañe la actualización del status en la pantalla de administración.',
    deactivatingDescription: 'La desactivación de su CDN fue solicitada y está en curso. Acompañe la actualización del status en la pantalla de administración.',
    cancelCta: 'Cancelar',
    confirmationCta: 'Ok, entendí',
    continueActivationCta: 'Activar CDN',
    continueDeactivationCta: 'Desactivar CDN',
    failedRequestTitle: 'Se ha producido un error en la solicitud',
    failedRequestDescription: 'Algo salió mal mientras procesábamos su solicitud. Por favor, inténtelo de nuevo.',
    domainWithProblemTitle: 'Dominio no disponible temporalmente',
    domainWithProblemDescription: 'No fue posible activar la CDN debido a problemas con su dominio, por favor, comuníquese con su registrante y confirme si hay algo pendiente.',
  },
  nameServerTooltip: (ns1, ns2) => (
    <>
      <strong>
        {'Servidor 1: '}
      </strong>
      {ns1}
      <br />
      <strong>
        {'Servidor 2: '}
      </strong>
      {ns2}
    </>
  ),
  refreshStatus: 'Actualizar status de la lista',
  noOpenStatus: 'No tiene ningún status abierto',
  waitRefreshTimeLimit: 'Espere hasta 1 hora para actualizar el status nuevamente',
  domainsError: 'Se produjo un problema al procesar su solicitud. Si persiste, intente nuevamente más tarde.',
  refreshList: 'Recarregar lista',
  messageWithActivationError: 'Ocurrió un error en su configuración. Inténtelo nuevamente y si el problema continúa, contáctese con el soporte',
  messageWithDeactivationError: 'Ocurrió un error en su intento de desactivación de la CDN. Intente de nuevo, y si el problema persiste, contacte al soporte.',
  genericErrorModal: {
    title: 'Ocurrió un error en su solicitud',
    description: 'Algo salió mal mientras procesábamos su solicitud. Por favor, intente nuevamente.',
    buttonLabel: 'Ok, entendí',
  },
  genericSuccessModal: {
    title: 'Su cambio fue realizado con éxito.',
    description: '',
    buttonLabel: 'Ok, entendí',
  },
  deleteRuleConfirmModal: {
    title: '¿Está seguro de que desea eliminar esta regla de bloqueo?',
    description: '',
    primaryButtonLabel: 'Sí, quiero eliminarla',
    secondaryButtonLabel: 'Cancelar',
  },
  deleteRuleSuccessModal: {
    title: 'Su regla de bloqueo se ha eliminado correctamente.',
    description: '',
    buttonLabel: 'Ok, entendí',
  },
  blockingErrorModal: {
    title: 'Se ha producido un error en su bloqueo',
    description: 'Hubo un problema en su intento de bloqueo Inténtelo de nuevo.',
    buttonLabel: 'Ok, entendí',
  },
  manageCdnHandler: {
    hostingLabel: planName => `Hospedaje: ${planName}`,
    selectedDomainLabel: 'Dominio seleccionado',
    changeButtonLabel: 'Cambiar',
    readMoreButton: toggleOn => (toggleOn ? 'Leer menos' : 'Leer más'),
    footerLabel: 'Estas funcionalidades utilizan los recursos de Cloudflare',
    cdnCards: {
      [FEATURES.PURGE_CACHE]: {
        cardTitle: 'Borrar caché',
        cardDescription: 'Elimine los archivos almacenados en caché para obligar al sistema a buscar una nueva versión de estos archivos de su servidor web. Borrar caché puede hacer que su sitio web se ralentice temporalmente y sobrecargue su servidor.',
        button: {
          buttonLabel: 'Borrar caché',
          secondsRemainingTooltip: ({ seconds }) => (
            <>
              {'Espere '}
              {seconds}
              {seconds > 1 ? ' segundos' : ' segundo'}
              {' para limpiar el caché nuevamente'}
            </>
          ),
        },
      },
      [FEATURES.DEV_MODE]: {
        cardTitle: 'Visualizar en tiempo real',
        cardDescription: 'Desactive temporalmente algunos recursos, como el almacenamiento en caché, la compresión y la optimización de archivos, durante tres horas (a menos que las desactive antes). Esto le permite ver inmediatamente cualquier cambio que realice en su sitio web.',
        tooltipLabel: (
          <>
            {'Esta funcionalidad utiliza el '}
            <strong>modo desarrollador</strong>
            {' de Cloudflare'}
          </>
        ),
        secondsRemainingTooltip: ({ seconds, isActive }) => (
          <>
            {'Espere '}
            {seconds}
            {seconds > 1 ? ' segundos' : ' segundo'}
            {' para '}
            {isActive ? 'desactivar' : 'activar'}
            {' esta funcionalidad nuevamente'}
          </>
        ),
      },
      [FEATURES.UNDER_ATTACK_MODE]: {
        cardTitle: 'Modo bajo ataque',
        cardDescription: 'Realiza verificaciones adicionales para proteger su sitio web contra ataques de virus. Permite el bloqueo de tráfico sospechoso. Utilice este modo cuando su sitio web esté siendo atacado. Cuando está activado, los visitantes verán una página de espera antes de acceder al sitio',
        secondsRemainingTooltip: ({ seconds, isActive }) => (
          <>
            {'Espere '}
            {seconds}
            {seconds > 1 ? ' segundos' : ' segundo'}
            {' para '}
            {isActive ? 'desactivar' : 'activar'}
            {' esta funcionalidad nuevamente'}
          </>
        ),
      },
      [FEATURES.ALWAYS_ONLINE]: {
        cardTitle: 'Mantener el sitio web siempre online',
        cardDescription: 'Mantenga su sitio web accesible incluso cuando el servidor está caído. Esta función utiliza copias de sus páginas guardadas en Wayback Machine (un servicio online que archiva y permite ver versiones antiguas de sitios de la internet).',
        tooltipLabel: (
          <>
            {'Esta funcionalidad utiliza el '}
            <strong>always online</strong>
            {' de Cloudflare'}
          </>
        ),
        secondsRemainingTooltip: ({ seconds, isActive }) => (
          <>
            {'Espere '}
            {seconds}
            {seconds > 1 ? ' segundos' : ' segundo'}
            {' para '}
            {isActive ? 'desactivar' : 'activar'}
            {' esta funcionalidad nuevamente'}
          </>
        ),
      },
    },
    cleanCacheModal: {
      loadingTitle: 'Limpieza de caché en curso',
      successTitle: 'Limpieza de caché realizada',
      successDescription: 'Su sitio web se actualizará con la última versión disponible en el servidor original.',
      failureTitle: 'Ocurrió un error al limpiar el caché',
      failureDescription: 'Hubo un problema al intentar limpiar el caché. Por favor, inténtelo de nuevo.',
      okButtonLabel: 'Ok, entendí',
    },
    cleanCacheModalError: {
      title: 'Ocurrió un error al limpiar el caché',
      description: 'Hubo un problema al intentar limpiar el caché. Por favor, inténtelo de nuevo.',
      buttonLabel: 'Ok, entendí',
    },
    tabs: {
      speed: 'Prueba de velocidad',
      tools: 'Herramientas',
      visitors: 'Visitantes',
      security: 'Seguridad',
    },
    speedAnalysis: {
      title: 'Prueba de velocidad',
      listTitle: 'Detalles del rendimiento de su sitio',
      firstRow: 'Ejecute la prueba de velocidad para analizar los tiempos de carga de la página, identificando posibles problemas de rendimiento. Tenga una mayor tasa de conversión asegurando un sitio web más rápido y eficiente.',
      secondRow: 'Puede realizar hasta 30 pruebas al mes. Una vez alcance este límite, las pruebas se renovarán el mes siguiente.',
      stillHave: ({ amount }) => (
        <>
          {'Aún le quedan '}
          <strong>
            {amount}
            {' testes'}
          </strong>
          {' pruebas por realizar'}
        </>
      ),
      dontHave: (
        <>
          {'Ya ha '}
          <strong>alcanzado el límite</strong>
          {' de la prueba'}
        </>
      ),
      initTestLabel: 'Iniciar prueba',
      reduTestLabel: 'Repetir la prueba',
      showList: 'Mostrar detalles',
      hideList: 'Ocultar detalles',
      testDate: date => `Fecha de la prueba: ${format(date, 'dd/MM/yyyy H:m')}`,
      results: {
        title: 'Resultado de su prueba',
        analysisTitle: {
          good: 'El sitio está con rápido rendimiento',
          neutral: 'El sitio está con rendimiento moderado',
          bad: 'El sitio está con bajo rendimiento',
        },
        failedTitle: 'Falla al realizar la prueba',
        failedDescription: domain => `No se puede realizar la prueba de velocidad en el dominio “${domain}” Compruebe si este dominio está alojado en nuestro servidor e inténtalo de nuevo.`,
        videoAbout: {
          title: 'Entiende los Resultados de su prueba',
          src: 'https://www.youtube.com/watch?v=PHiXol3rmxs',
        },
        items: {
          ttfb: 'Tiempo hasta el primer byte cargar (TTFB)',
          ttfbTooltip: 'Time to First Byte es el tiempo que tarda su computadora en comenzar a recibir las primeras informaciones de un sitio web después de  hacer clic para acceder a él. Cuanto más corto sea este tiempo, más rápido aparecerá el sitio.',
          fcp: 'Tiempo en que aparece el primer contenido de la pantalla (FCP)',
          fcpTooltip: 'First Contentful Paint es el momento en el que usted comienza a ver algo útil en la pantalla al cargar un sitio web. Es la primera vez que el sitio le muestra algo que usted pueda ver, como texto, imágenes o gráficos.  Cuanto más rápido suceda esto, más rápido sentirá que se está cargando el sitio web.',
          lcp: 'Tiempo en que aparece el contenido más grande del sitio (LCP)',
          lcpTooltip: 'Largest Contentful Paint es cuando la más grande y relevante pieza de contenido aparece en la pantalla, como una imagen grande,  un vídeo o un bloque principal de texto.  Cuanto más rápido suceda esto, más rápido usted siente que el sitio termino de cargar el contenido principal.',
          tti: 'Tiempo para que el sitio esté listo para su uso (TTI)',
          ttiTooltip: 'Time to Interactive es el tiempo que tarda el sitio web en estar listo para ser utilizado, es decir, el tiempo que tarda no sólo en aparecer, sino en estar completamente listo para que usted interactúe con él, sin que se bloquee o tarde en responder.',
          tbt: 'Tiempo de bloqueo durante la carga (TBT)',
          tbtTooltip: 'Total Blocking Time mide el tiempo en que el sitio web se bloquea y no responde a las interacciones, como los clics o la escritura. Es el período en el que está cargando o procesando algo y no le responde de inmediato. Cuanto más corto sea este tiempo, más fluida será la experiencia de uso.',
          si: 'Velocidad a la que aparece el contenido visible del sitio web (SI)',
          siTooltip: 'Speed Index es una medida de la rapidez con la que aparece el contenido visible de un sitio web mientras se está cargando. Es una forma de medir la rapidez con la que ve que la página toma forma y se vuelve útil, incluso si aún no se está cargando por completo. Cuanto más bajo sea el índice, más rápido verá que el sitio web se vuelve visible.',
          cls: 'Estabilidad visual de la página al cargar (CLS)',
          clsTooltip: 'Cumulative Layout Shift mide cuánto cambia el contenido de un sitio web mientras se carga. Para un sitio web, esto ocurre cuando el texto o las imágenes cambian de posición mientras intentas interactuar con la página. Cuanto menor sea el cambio, más estable y cómoda será la experiencia de uso.',
        },
      },
      historyList: {
        title: 'Histórico de resultados',
        date: 'Fecha',
        domain: 'Dominio',
        score: 'Puntuación',
        showDetails: 'Mostrar detalles',
        itemsPerPage: 'Itens por página: ',
      },
      getHistoryListError: {
        title: 'Falla al cargar los datos',
        description: 'No fue posible cargar los datos solicitados. Por favor, espere y vuelva a intentarlo en unos minutos.',
      },
    },
    progressBar: {
      texts: [
        'Iniciando...',
        'Analizando el sitio...',
        'Generando el relatório...',
      ],
    },
    visitors: {
      visitsOnSiteTitle: 'Visitas en el sitio',
      totalOfAccess: 'Total de accesos',
      maxOfVisitants: 'Máximo de visitantes únicos',
      minOfVisitants: 'Mínimo de visitantes únicos',
      perDay: 'Por un día',
      perHour: 'Por uma hora',
      uniqueVisitants: 'Visitantes únicos',
      startTimeEndTime: (startTime, endTime) => `De ${startTime}\nHasta ${endTime}`,
      selectOptions: {
        last24hours: '24 horas anteriores',
        last7Days: '7 días anteriores',
        last30Days: '30 días anteriores',
      },

      regionsOfAccessTitle: 'Principales países/regiones de acceso',
      countryTitle: 'País/Región',
      trafficTitle: 'Tráfico',
      perPageLabel: 'Itens por página',
      noDataTitle: 'Todavía no hay datos para mostrar',
      noDataDescription: 'Su sitio aún no tiene datos de visitas para mostrar.',
      errorStateTitle: 'Falla al cargar los datos',
      errorStateDescription: 'No fue posible cargar los datos solicitados. Por favor, espere y vuelva a intentarlo en unos minutos.',
    },
    security: {
      rules: {
        title: 'Nombre de la regla',
        description: 'Asigne un nombre descriptivo a la regla',
        inputLabel: 'Ej: regla de bloqueo por país duplicado',
        ruleBlockedUntil: (isEnabled, seconds) => `Podrás ${isEnabled ? 'desactivar' : 'activar'} esta regla nuevamente en ${seconds} segundos`,
        createRuleBlockedUntil: seconds => `Podrás crear una nueva regla en ${seconds} segundos`,
        editRuleBlockedUntil: seconds => `Por favor, espere. Podrás editar esta regla nuevamente en ${seconds} segundos`,
        noChanges: 'Cambia al menos un campo para guardar la edición de la regla',
      },
      traficBlock: {
        title: 'Bloqueo de tráfico',
        rulesLeftInfo: rulesLeft => (
          <span>
            Tienes
            {' '}
            <strong>
              {rulesLeft}
              {' '}
              reglas
              {' '}
            </strong>
            {rulesLeft === 1 ? 'disponible' : 'disponibles'}
          </span>
        ),
        noRulesLeftInfo: () => (
          <span>
            Ya ha alcanzado el
            {' '}
            <strong>límite de 5 reglas</strong>
            {' '}
            de bloqueo creadas, para continuar elimine una de ellas de la lista de bloqueo.
          </span>
        ),
        description: 'Seleccione el tipo de bloqueo',
        selectPlaceholder: 'Seleccionar',
        ruleTypes: {
          [RuleActionTypes.COUNTRY]: {
            label: 'País',
            ruleValuePlaceholder: 'Seleccionar país',
          },
          [RuleActionTypes.CONTINENT]: {
            label: 'Continente',
            ruleValuePlaceholder: 'Seleccionar continente',
          },
          [RuleActionTypes.SOURCE_IP_ADDRESS]: {
            label: 'Dirección por IP',
            ruleValuePlaceholder: 'Dirección por IP, ej: 192.158.1.38',
          },
          [RuleActionTypes.URL]: {
            label: 'Dirección del sitio web - URL',
            ruleValuePlaceholder: 'Ejemplo URL: www.misitio.com',
          },
        },
        button: 'Bloquear',
      },
      blockList: {
        title: 'Lista de bloqueos',
        order: 'Orden',
        name: 'Nombre',
        action: 'Acción',
        toggleOn: 'Habilitado',
      },
      dropdownActions: {
        edit: 'Editar',
        duplicate: 'Duplicar',
        delete: 'Eliminar',
      },
      addRuleModalSuccess: {
        title: 'Su bloqueo se ha realizado con éxito',
        description: rulesLeft => (
          <>
            <div>
              Verifique los detalles de la acción en su lista de bloqueo.
            </div>
            <div>
              Todavía tienes
              {' '}
              <strong>
                {rulesLeft}
                {' '}
                {rulesLeft === 1 ? 'regla' : 'reglas'}
                {' '}
              </strong>
              {`de bloqueo ${rulesLeft === 1 ? 'disponible' : 'disponibles'}`}
            </div>
          </>
        ),
        buttonLabel: 'Ok, entendí',
      },
      getRulesError: {
        title: 'Falla al cargar los datos',
        description: 'No fue posible cargar los datos solicitados. Por favor, espere y vuelva a intentarlo en unos minutos.',
      },
    },
  },
  cloudflareBanner: {
    title: 'Su sitio web más rápido y seguro con la CDN de Cloudflare',
    description: 'Acelere el tiempo de carga de su sitio web, proporcionando una experiencia más rápida y satisfactoria para sus visitantes de forma gratuita.',
    buttonCta: 'Ir a rendimiento del sitio',
  },
  topBanner: {
    title: 'Su sitio web más rápido y seguro con la CDN de Cloudflare gratis',
    description: 'Los sitios de su plan ya tienen acceso a las funcionalidades de rendimiento y seguridad de la CDN gratis',
    cta: 'Consulte',
    modal: {
      title: 'Conozca la CDN de Cloudflare',
      know: {
        title: '¿Qué es la CDN de Cloudflare?',
        description: 'La CDN (Content Delivery Network) es una red de servidores distribuidos globalmente que entrega contenido de Internet de manera más rápida, eficiente y segura.',
      },
      speed: {
        title: 'Mayor velocidad del sitio',
        description: 'Con la CDN, el contenido de su sitio se entrega desde servidores más cercanos de sus visitantes, lo que hace que las páginas se carguen más rápido.',
      },
      stability: {
        title: 'Mayor estabilidad',
        description: 'Si un servidor falla, la CDN redirige el tráfico a otro, manteniendo el sitio en funcionamiento.',
      },
      safety: {
        title: 'Mayor seguridad',
        description: 'Protege el sitio web de los ciberataques, como los intentos de derribarlo con tráfico excesivo (DDoS).',
      },
      settup: {
        title: 'Configure su CDN en rendimiento del sitio',
        description: 'Acelere y proteja su sitio web con la CDN de Cloudflare. Comience hoy y mejore su rendimiento online',
        cta: 'Ir a rendimiento del sitio',
      },
    },
  },
  whatIsCdnModal: {
    title: '¿Qué es la CDN?',
    description: 'La CDN (Content Delivery Network) es una red de servidores distribuidos globalmente que entrega contenido de Internet de manera más rápida, eficiente y segura. Tener una CDN trae ventajas a su sitio web como:',
    items: [
      {
        icon: 'IconCdn',
        featureBackground: 'attentionPure',
        iconSecondaryColor: 'attentionUltraLight',
        title: 'Más velocidad',
        description: 'El contenido de su sitio se entrega desde servidores más cercanos de sus visitantes, lo que hace que las páginas se carguen más rápido.',
      },
      {
        icon: 'IconSecurityCheck',
        featureBackground: 'activeLight',
        iconSecondaryColor: 'activeUltraLight',
        title: 'Más seguridad',
        description: 'Protege el sitio web de los ciberataques, como los intentos de derribarlo con tráfico excesivo (DDoS).',
      },
      {
        icon: 'IconLive',
        featureBackground: 'pendingPure',
        iconSecondaryColor: 'attentionUltraLight',
        title: 'Mayor estabilidad',
        description: 'Si un servidor falla, la CDN redirige el tráfico a una versión de su contenido almacenada en caché, manteniendo su sitio siempre online.',
      },
    ],
    cta: 'Ok, entendí',
  },
};
